// vendor
import {defineComponent, ref, PropType, computed, watch } from "@vue/composition-api";
// project
import { formatDateString } from "@/utils/text";
import * as AssetAPI from "@/services/api/assets";
import { getAssetTypes } from "@/psychlab/meta";
import { Asset, AssetPointer, AssetVersion } from "@/psychlab/types";
import { BrowseAssetModal } from "@/components.assets/browse-asset-modal";

export const FindAsset = defineComponent({

	emits:[ "input" ],
	components:{
		BrowseAssetModal,
	},
	props:{
		size:{
			type:String,
			default:"md"
		},
		value:{
			type:Object as PropType<AssetPointer<any>|null>,
			default:null
		},
		types:{
			type:Array as PropType<string[]>,
			default: () => []
		},
		modalTitle:{
			type:String,
			default:"Find Asset"
		},
		modalIcon:{
			type:String,
			default:"mdi.feature-search"
		},
		placeholder:{
			type:String,
			default:"Select Asset..."
		},
		tag:{
			type:String,
		}
	},
	setup(props, context){

		const browseAssetModal = ref<any>("");
		const assetMissing = ref(false);
		const selectedAsset = ref<Asset>();

		const versions = ref<AssetVersion<any>[]>([]);

		const label = computed(() => {
			if(assetMissing.value){ return "Asset missing or deleted"; }
			if(selectedAsset.value){
				return selectedAsset.value.name;
			}
			return "";
		});

		const icon = computed(() => {
			if(selectedAsset.value){
				const type = getAssetTypes().find(t => t.name === (selectedAsset.value as any).type);
				return type ? type.icon : "";
			}
			return "";
		});

		const activeVersion = computed(() => {
			if(!versions.value.length){ return null; }
			return versions.value.find(v => v._id === (props.value as any).ref.version);
		});

		const usingLatest = computed(() => {

			if(!activeVersion.value){ return false; }
			const max = Math.max(...versions.value.map(v => v.vIndex));
			return max === activeVersion.value.vIndex;
		});


		watch(() => props.value, () => refresh(), { deep:true });

		watch(() => props.value, (o, n) => {
			if(o && o.ref && n && n.ref){
				if(JSON.stringify(o.ref) === JSON.stringify(n.ref)){
					return;
				}
			}
			assetMissing.value = false;
		});

		const refresh = async() => {
			if(!props.value || !props.value.ref || assetMissing.value) { selectedAsset.value = undefined; return; }
			try{
				selectedAsset.value = await AssetAPI.getAsset(props.value.ref.asset);
				versions.value = await AssetAPI.loadVersionList(props.value.ref.asset);
			}catch(err){
				assetMissing.value = true;
			}
		};

		const findAsset = async() => {
			if(!props.types.length){ return; }
			const assetType = props.types[0];
			const value = props.value ? props.value.ref : null;
			const m = browseAssetModal.value;

			m.open({ value, assetType, tag:props.tag }, async(result:{ asset:string, version:string }) => {
				var { data } = await AssetAPI.getAssetVersion(result.asset, result.version, "data");
				var value = {
					ref:result,
					data
				};
				assetMissing.value = false;
				context.emit("input", value);
			});
		};

		refresh();

		return {
			usingLatest,
			browseAssetModal,
			assetMissing,
			selectedAsset,
			label,
			icon,
			activeVersion,
			findAsset
		};
	}


});
